import { ComponentChildren, h, JSX, Fragment } from "preact";

import { useState } from "preact/hooks";

import { ToastVariant } from "../../../foundation/enums";
import classname from "../../../foundation/utils/classname";
import { stopPropagation } from "../../../foundation/utils/legacy";

import IconArrowLeft from "../Icons/IconArrowLeft";
import IconCheck from "../Icons/IconCheck";
import IconLock from "../Icons/IconLock";

import styles from "./Toast.module.css";

type NativeDivProps = JSX.HTMLAttributes<HTMLDivElement>;

type ToastButtonProps = {
    children: string;
    onClick?: (ev?: MouseEvent) => void;
};

interface Props extends NativeDivProps {
    variant?: ToastVariant;
    primaryButtonProps?: ToastButtonProps;
    secondaryButtonProps?: ToastButtonProps;
    renderCustomIcon?: () => ComponentChildren;
    onMouseEnter?(): void;
    onMouseLeave?(): void;
    onClick?: (ev?: MouseEvent) => void;
}

function Toast({
    class: cssClass,
    variant = ToastVariant.Success,
    children,
    renderCustomIcon,
    primaryButtonProps,
    secondaryButtonProps,
    onMouseEnter,
    onMouseLeave,
    onClick,
    ...nativeDivProps
}: Props) {
    const actionButtonTextClass = "body-1 medium";
    const [lockState, setLockState] = useState(false);

    function handleClick(ev: MouseEvent) {
        if (variant === ToastVariant.ToggleLock) {
            setLockState(!lockState);
        }

        onClick?.(ev);
    }

    return (
        <div
            class={classname(styles.toast, cssClass, styles[variant])}
            onMouseDown={stopPropagation}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={variant === ToastVariant.ToggleLock ? handleClick : onClick}
            {...nativeDivProps}>
            {
                renderCustomIcon
                    ? renderCustomIcon()
                    : (
                        <>
                            {
                                variant === ToastVariant.Success && (
                                    <IconCheck class={styles.check} color="var(--marker-jade)"/>
                                )
                            }
                            {
                                variant === ToastVariant.ToggleLock && (
                                    lockState
                                        ? <IconArrowLeft color="var(--label-accent)"/>
                                        : <IconLock/>
                                )
                            }
                        </>
                    )
            }
            <span class="body-1">{children}</span>
            {
                (primaryButtonProps || secondaryButtonProps) && (
                    <div class={classname(styles.buttonGroup)}>
                        {
                            primaryButtonProps && (
                                <span
                                    class={classname(styles.actionButton, actionButtonTextClass, styles.primary)}
                                    {...primaryButtonProps}/>
                            )
                        }
                        {
                            secondaryButtonProps && (
                                <span
                                    class={classname(styles.actionButton, actionButtonTextClass, styles.secondary)}
                                    {...secondaryButtonProps}/>
                            )
                        }
                    </div>
                )
            }
        </div>
    );
}

export default Toast;
export { Props as ToastProps };
